import React, { Component } from 'react';
import './Courses.css';

export default class Courses extends Component {

  componentDidMount(){
    this.props.heightUpdate(this.divElement.clientHeight);
  }

  render() {
    return(
      <div id="courses-container" className="courses-container" ref={divElement => this.divElement = divElement}>
        <div className="courses-section">
          <h1 className="courses-title">Courses</h1>
          <div className="courses-information">
            <div className="courses-row">
              <div className="courses-year">
                <h2>Freshmen</h2>
                <div className="courses-fall">
                  <h3>Fall</h3>
                  <ul>
                    <CSCourse
                      courseName = 'Theory of Computation'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE150'
                    />
                    <li>Calculus II</li>
                    <li>Elements of Music</li>
                    <li>Intermediate Writing</li>
                    <li>Introduction Seminar</li>
                  </ul>
                </div>
                <div className="courses-spring">
                  <h3>Spring {/*&amp; Summer*/}</h3>
                  <ul>
                    <CSCourse
                      courseName = 'Computer Science A: Honors'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE160'
                    />
                    <CSCourse
                      courseName = 'Computer Science A Lab'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE161'
                    />
                    <CSCourse
                      courseName = 'System Fundamentals I'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE220'
                    />
                    <li>Multivariable Calculus</li>
                    <li>Linear Algebra</li>
                    <li>American Government</li>
                    <li>Global Studies</li>
                    {/*<li>Classical Physics I</li>
                    <li>Classical Physics Lab I</li>
                    <li>Classical Physics II</li>
                    <li>Classical Physics Lab II</li>*/}
                  </ul>
                </div>
              </div>

              <div className="courses-year">
                <h2>Sophomore</h2>
                <div className="courses-fall">
                  <h3>Fall</h3>
                  <ul>
                    <CSCourse
                      courseName = 'Computer Science B: Honors'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE260'
                    />
                    <CSCourse
                      courseName = 'Computer Science B Lab'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE261'
                    />
                    <CSCourse
                      courseName = 'System Fundamentals II'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE320'
                    />
                    <li>Differential Equations</li>
                    <li>Finite Mathematical Structures</li>
                    <li>Probability and Statistics</li>
                    <li>Structural Principles of Music I</li> 
                    <li>Music of Beethoven</li>
                  </ul>
                </div>
                <div className="courses-spring">
                  <h3>Spring</h3>
                  <ul>
                    <CSCourse
                      courseName = 'Theory of Computation: Honors'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE350'
                    />
                    <CSCourse
                      courseName = 'Machine Learning'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE353'
                    />
                    <CSCourse
                      courseName = 'Computer Networks'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE310'
                    />
                    <CSCourse
                      courseName = 'Technical Communciations'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE300'
                    />
                    <li>Structural Principles of Music II</li>
                    <li>Introduction to Music</li>
                  </ul>
                </div>
              </div>

              <div className="courses-year">
                <h2>Junior</h2>
                <div className="courses-fall">
                  <h3>Fall</h3>
                  <ul>
                    <CSCourse
                      courseName = 'Analysis of Algorithms: Honors'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE373'
                    />
                    <CSCourse
                      courseName = 'Operating Systems'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE306'
                    />
                    <CSCourse
                      courseName = 'Computer Security Fundamentals'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE331'
                    />
                    <li>Applied Algebra</li>
                    <li>Piano</li>
                    <li>Elementary Korean I</li>
                  </ul>
                </div>
                <div className="courses-spring">
                  <h3>Spring</h3>
                  <ul>
                    <CSCourse
                      courseName = 'Cloud Computing'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE356'
                    />
                    <CSCourse
                      courseName = 'Offensive Security'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE363'
                    />
                    <CSCourse
                      courseName = 'Principles of Database Systems'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE305'
                    />
                    <li>Data Analysis</li>
                    <li>Imaginative World of Opera</li>
                    <li>Chorale</li>
                  </ul>
                </div>
              </div>

              <div className="courses-year">
                <h2>Senior</h2>
                <div className="courses-fall">
                  <h3>Fall</h3>
                  <ul>
                    <CSCourse
                      courseName = 'Senior Honors Research Project I'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE495'
                    />
                    <CSCourse
                      courseName = 'Software Engineering'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE308'
                    />
                    <CSCourse
                      courseName = 'Computational Geometry'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE355'
                    />
                    <li>Deterministic Models</li>
                    <li>The Earth</li>
                  </ul>
                </div>
                <div className="courses-spring">
                  <h3>Spring</h3>
                  <ul>
                    <CSCourse
                      courseName = 'Senior Honors Research Project II'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE496'
                    />
                    <CSCourse
                      courseName = 'Ethical Issues in Information Systems'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Undergraduate-Studies/courses/CSE312'
                    />
                    <CSCourse
                      courseName = 'Big Data Analytics (Graduate)'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Graduate-Studies/courses/CSE545'
                    />
                    <CSCourse
                      courseName = 'Computation Geometry (Graduate)'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Graduate-Studies/courses/CSE555'
                    />
                    <CSCourse
                      courseName = 'Computer System Security (Graduate)'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Graduate-Studies/courses/CSE509'
                    />
                  </ul>
                </div>
              </div>

              <div className="courses-year">
                <h2>Masters</h2>
                <div className="courses-fall">
                  <h3>Fall</h3>
                  <ul>
                    <CSCourse
                      courseName = 'Advanced Project in Computer Science I'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Graduate-Studies/courses/CSE523'
                    />
                    <CSCourse
                      courseName = 'Distributed Systems'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Graduate-Studies/courses/CSE535'
                    />
                    <CSCourse
                      courseName = 'Analysis of Algorithms'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Graduate-Studies/courses/CSE548'
                    />
                    <CSCourse
                      courseName = 'Fundamentals of Computer Networks'
                      courseLink = 'https://www.cs.stonybrook.edu/students/Graduate-Studies/courses/CSE534'
                    />
                  </ul>
                </div>
                <div className="courses-spring">
                  <h3>Spring</h3>
                  <ul>
                    <li>TBA</li>
                  </ul>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div className="courses-info-text">* Underlines indicate computer science courses that can be clicked for more information</div>
        <div className="courses-info-text">* Physics I and II and Physics Lab I and II were taken during the summer of Freshmen year</div>
      </div>
    );
  }
}

class CSCourse extends Component {
  render() {
    return (
      <li className='course-cs'>
        <a href={this.props.courseLink} rel="noopener noreferrer" target="_blank">
          {this.props.courseName}
        </a>
      </li>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Courses/Courses.js